module.exports = __webpack_public_path__ + "static/media/Fs6v6.bc9655eb.mp3";